module.exports = __webpack_public_path__ + "f24ba014f8db993fcbd643c8ae9ae127.pdf";